import { assert } from "superstruct";
import { PlatformUiEnv } from "../platform-ui-envs.type";

export const usePlatformUiEnv = (): PlatformUiEnv => {
  const env = process.env.REACT_APP_PUI_ENV;
  assert(env, PlatformUiEnv);
  return env;
};
